import { controlApiFetch } from "@/transport/control-api"
import { jsonArray, jsonBoolean, jsonNumber, jsonObject, jsonString } from "@/transport/decode"
import { expectJson } from "@/transport/http"

/** A workspace as its machine last reported it to the account. */
export type InventoryWorkspace = {
  id: string
  name: string
  directory: string
  defaultProject: string
  closed: boolean
}

/** One machine's last workspace report. */
export type MachineWorkspaces = { machine: string; reportedAt: number; workspaces: InventoryWorkspace[] }

const invalid = "Server returned an invalid workspace list"

function decodeWorkspace(value: unknown): InventoryWorkspace {
  const workspace = jsonObject(value, invalid)
  return {
    id: jsonString(workspace.id, invalid),
    name: jsonString(workspace.name, invalid),
    directory: jsonString(workspace.directory, invalid),
    defaultProject: jsonString(workspace.defaultProject, invalid),
    closed: jsonBoolean(workspace.closed, invalid),
  }
}

/** Every machine's last reported workspaces, offline machines' included. */
export async function listAccountWorkspaces(signal?: AbortSignal): Promise<MachineWorkspaces[]> {
  return expectJson(await controlApiFetch("/api/workspaces", { signal }), (value) =>
    jsonArray(jsonObject(value, invalid).machines, invalid).map((item) => {
      const machine = jsonObject(item, invalid)
      return {
        machine: jsonString(machine.machine, invalid),
        reportedAt: jsonNumber(machine.reportedAt, invalid),
        workspaces: jsonArray(machine.workspaces, invalid).map(decodeWorkspace),
      }
    }),
  )
}
